export default __webpack_public_path__ + "static/media/Easy-Pension-Brochure.2248275d.pdf";